import { render, staticRenderFns } from "./EmployeeCode.vue?vue&type=template&id=874291a8"
import script from "./EmployeeCode.vue?vue&type=script&lang=js"
export * from "./EmployeeCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports